import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 4v3h5.5v12h3V7H19V4H5z"
}), 'TitleOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TitleOutlined.js
// module id = 6835
// module chunks = 2